import type { Country } from "@tandemdiabetes/sugarmate-api-react-client"
import { useGetSupportedCountries } from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import type { SWRResponse } from "swr"
import useSWR from "swr"

import { useCountriesSWRKey } from "./useCountriesSWRKey"

/*
 * we need this baseURL to request countries
 *
 * the ApiContextProvider provides a baseURL to all api queries once the user
 * selects a country, but requesting the list of countries comes before that
 * selection is made
 */
const baseURL: string = process.env.REACT_APP_SUGARMATE_BASE_URL ?? ""

export function useCountries(): SWRResponse<Array<Country>> {
  const countriesSWRKey = useCountriesSWRKey()
  const getCountries = useGetSupportedCountries(baseURL)

  const getCountriesData = useMemo(
    () => !getCountries ? null : (async () => {
      const response = await getCountries()
      return response.data.supported_countries
    }),
    [getCountries],
  )

  return useSWR<Array<Country>>(
    countriesSWRKey,
    getCountriesData,
  )
}
